import React from 'react';

const PlusInCircleIcon = () => (
    <svg className="icon icon-plus-in-circle" viewBox="0 0 28 28">
        <path
            d="M14 0c7.732 0 14 6.268 14 14s-6.268 14-14 14S0 21.732 0 14 6.268 0 14 0zm0 1.5C7.096 1.5 1.5 7.096 1.5 14S7.096 26.5 14 26.5 26.5 20.904 26.5 14 20.904 1.5 14 1.5zM14 6c.414 0 .75.336.75.75v6.5h6.5c.414 0 .75.336.75.75s-.336.75-.75.75h-6.5v6.5c0 .414-.336.75-.75.75s-.75-.336-.75-.75v-6.5h-6.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h6.5v-6.5c0-.414.336-.75.75-.75z"
            transform="translate(-166 -249) translate(40 202) translate(20 47) translate(106)"
        />
    </svg>
);

export default PlusInCircleIcon;
